<div *ngIf="data" class="container my-2">
    <div class="d-flex justify-content-between align-items-center mb-4 logo">

        <!-- LOGO SECTION FOR HOMEPAGE -->
        <div *ngIf="data?.partnerLogo" class="image-box text-center">
            <div class="">
                <ng-container>
                    <img class="partnerLogo" [src]="data?.partnerLogo" alt="Visa">
                </ng-container>
                <ng-template #privateLogo>
                    <fa-async-image [src]="data?.partnerLogo" [alt]="'image'"></fa-async-image>
                </ng-template>
            </div>
        </div>

        <!-- NAVIGATION TABS (Dashboard only) -->
        <div *ngIf="data?.ngbNav">
            <ul ngbNav [(activeId)]="activeTab" #nav="ngbNav" class="nav nav-tabs">
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': data?.setActiveTab === 'overview' }"
                        (click)="onTabClick('overview')" data-bs-toggle="tab" href="#overview">
                        Dashboard
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': data?.setActiveTab === 'my-tests' }"
                        (click)="onTabClick('my-tests')" data-bs-toggle="tab" href="#my-tests">
                        Previous Test Scores
                    </a>
                </li>
            </ul>
        </div>

        <!-- RIGHT SIDE BUTTONS -->
        <div class="d-flex justify-content-between align-items-center">

            <!-- HOMEPAGE BUTTONS -->
            <div class="d-flex justify-content-end align-items-center">
                <button *ngIf="data?.showLoginBtn"
                    [ngClass]="data?.showLoginBtn ? 'border border-primary rounded-1' : 'btn-transparent'"
                    (click)="onLogin()" class="btn text-primary fw-bold me-2">
                    Login
                </button>
                <button *ngIf="data?.showGetStartedBtn" (click)="onGetStarted()"
                    class="btn btn-primary text-white get-started">
                    Get Started <i class="bi bi-chevron-right"></i>
                </button>
            </div>

            <!-- DASHBOARD/INSIGHTS BUTTONS -->
            <div class="d-flex justify-content-between align-items-start">
                <div *ngIf="data?.help" class="me-2">
                    <fa-help-component (click)="onHelp()"></fa-help-component>
                </div>

                <button *ngIf="data?.visaMonkExpires" class="btn btn-outline-expiry me-2 satoshi-bold">
                    <span><img class="img img-fluid me-1 mt-n1"
                            src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1731395180307alarm.png"
                            alt="" /></span>
                    <span><small>Visa Mocks expire in </small></span>
                    <span class="text-primary">{{ data?.codeExpiry }} Days</span>
                </button>

                <div>
                    <button *ngIf="data?.logout" (click)="onLogout()" class="btn btn-outline-primary button-logout">
                        Logout <span><i class="bi bi-box-arrow-right"></i></span>
                    </button>
                </div>

            </div>

            <!-- PARTNER BUTTONS -->
            <div *ngIf="data?.partnerSignin" class="d-flex justify-content-end align-items-center">
                <button (click)="onPartnerSignin()" class="btn btn-primary text-white get-started">
                    Partner Sign-in <i class="bi bi-chevron-right"></i>
                </button>
            </div>
        </div>
    </div>
</div>

<!-- HR line for dashboard and insights -->
<hr class="mt-n3" *ngIf="type === 'dashboard' || type === 'insights'" />